import Vue from 'vue';
import VueRouter from 'vue-router';

import login from '../page/login';
import shop from '../page/shop';
import basic from '../page/basic';
import basics from '../page/basic/index/index';
import update from '../page/basic/update';
import administrators from '../page/administrators';
import administrators_update from '../page/administrators/update';
import loginUpdate from '../page/update';
import employee from '../page/employee';
import insert from '../page/employee/insert';
import detail from '../page/employee/detail';
import dailymenu from '../page/daily-menu';
import dinnertime from '../page/dinner-time';
import salesanalysis from '../page/sales-analysis';
import costanalysis from '../page/cost-analysis';
import customerstatistic from '../page/customer-statistic';
import category from '../page/category';
import raw from '../page/dish_raw';
import dish from '../page/dish';
import dish_take from '../page/dish_take';
import dish_menu_list from '../page/dish_menu';

import sidedish from '../page/sidedish';
import label from '../page/label';
import dish_unit from '../page/dish_unit';

import stove from '../page/stove';

import plate from '../page/plate';
import flow from '../page/flow';
import flow_detail from '../page/flow_detail';
import viplist from '../page/viplist';
import vipHistory from '../page/vipHistory';
import company from '../page/company';
import coupon from '../page/coupon';
import history from '../page/history';
import blank from '../page/blank';
import ackkitchen from '../page/ackkitchen';
import company_info from '../page/company_info';
import orderVip from '../page/ordervip';
import refund from '../page/refund';
import management_analysis from '../page/management_analysis';
import management_price from '../page/management_price';
import management_raw from '../page/management_raw';
import management_new from '../page/management_new';
import management_dish from '../page/management_dish';
import receipt  from "@/page/receipt";

// company_info
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const AdminChildren = [
  { path: '/shop/basic', name: 'basic', component: basic },
  { path: '/shop/company_info', name: 'company_info', component: company_info },
  { path: '/shop/basics', name: 'basics', component: basics },
  { path: '/shop/basics/:id', name: 'basics', component: basics },
  { path: '/shop/basic/update/:id', name: 'update', component: update },
  { path: '/shop/basic/update', name: 'update', component: update },
  {
    path: '/shop/basic/administrators',
    name: 'administrators',
    component: administrators,
  },
  {
    path: '/shop/administrators/update',
    name: 'administrators_update',
    component: administrators_update,
  },
  { path: '/shop/employee', name: 'employee', component: employee },
  { path: '/shop/employee/insert/:id', name: 'insert', component: insert },
  { path: '/shop/employee/detail/:id', name: 'detail', component: detail },
  { path: '/shop/employee/insert', name: 'insert', component: insert },
  { path: '/shop/daily-menu', name: 'daily-menu', component: dailymenu },
  { path: '/shop/dinner-time', name: 'dinner-time', component: dinnertime },
  {
    path: '/shop/sales-analysis',
    name: 'sales-analysis',
    component: salesanalysis,
  },
  {
    path: '/shop/cost-analysis',
    name: 'cost-analysis',
    component: costanalysis,
  },
  {
    path: '/shop/management-analysis',
    name: 'management_analysis',
    component: management_analysis,
  },
  {
    path: '/shop/management-raw',
    name: 'management-raw',
    component: management_raw,
  },
  {
    path: '/shop/management-price',
    name: 'management_price',
    component: management_price,
  },
  {
    path: '/shop/management-new',
    name: 'management_new',
    component: management_new,
  },
  {
    path: '/shop/management-dish',
    name: 'management_dish',
    component: management_dish,
  },
  {
    path: '/shop/customer-statistic',
    name: 'customer-statistic',
    component: customerstatistic,
  },
  { path: '/food/raw', name: 'raw', component: raw },
  { path: '/food/category', name: 'category', component: category },
  { path: '/food/dish', name: 'dish', component: dish },
  { path: '/food/dish/take', name: 'dish_take', component: dish_take },
  {
    path: '/food/dish/dish_menu_list',
    name: 'dish_menu_list',
    component: dish_menu_list,
  },
  { path: '/food/sidedish', name: 'sidedish', component: sidedish },
  { path: '/food/label', name: 'label', component: label },
  { path: '/food/dish_unit', name: 'dish_unit', component: dish_unit },
  { path: '/device/stove', name: 'stove', component: stove },
  { path: '/device/receipt', name: 'receipt', component: receipt },
  { path: '/device/plate', name: 'plate', component: plate },
  { path: '/finance/flow', name: 'flow', component: flow },
  { path: '/finance/flow_detail', name: 'flow_detail', component: flow_detail },
  { path: '/finance/viplist', name: 'viplist', component: viplist },
  { path: '/finance/vipHistory', name: 'vipHistory', component: vipHistory },

  { path: '/finance/viplists', name: 'viplists', component: viplist },
  { path: '/prepay/company', name: 'company', component: company },
  { path: '/promotion/coupon', name: 'coupon', component: coupon },
  { path: '/promotion/history', name: 'history', component: history },
  { path: '/order/vip', name: 'history', component: orderVip },
  { path: '/refund/list', name: 'refund', component: refund },
];
const Adminplatform = [
  { path: '/platform/shop/basic', name: 'login', component: basic },
];
const routes = [
  { path: '/', name: 'login', component: login },
  { path: '/login', name: 'login', component: login },
  { path: '/login/update', name: 'update', component: loginUpdate },
  { path: '/blank/basic', name: 'blank', component: blank },
  { path: '/ackkitchen', name: 'ackkitchen', component: ackkitchen },
  {
    path: '/shop',
    name: 'shop',
    component: shop,
    children: AdminChildren,
  },
  {
    path: '/platform/shop',
    name: '/platform/shop',
    component: shop,
    children: Adminplatform,
  },
  { path: '*', name: 'login', redirect: '/' }, //防输错或者没找到页面路由错误，跳转到首页
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path == '/login' || to.path == '/login/update') {
    next();
  } else {
    if (!localStorage.getItem('KC_token')) {
      alert('您还没有登录，请先登录');
      next('/login');
    } else {
      next();
    }
  }
});
export default router;
